import { apiV2Client, apiFileClient } from '@/services/client/ApiClient.js';
import { handleError } from '@/services/ErrorHandler.js';

export default {
  getPins(layerId) {
    return apiV2Client.get(`/drawings/${layerId}/pins`).then((response) => {
      return response.data;
    });
  },
  addPin(layerId, data) {
    return apiV2Client
      .post(`/drawings/${layerId}/pins`, data)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  addAttachments(pinId, layerId, data) {
    return apiFileClient
      .post(`/drawings/${layerId}/pins/${pinId}/attachments`, data)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  deleteAttachment(pinId, layerId, id) {
    return apiFileClient
      .delete(`/drawings/${layerId}/pins/${pinId}/attachments/${id}`)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  addComment(pinId, layerId, data) {
    return apiV2Client
      .post(`/drawings/${layerId}/pins/${pinId}/comments`, data)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  addPhoto(pinId, layerId, data) {
    return apiFileClient
      .post(`/drawings/${layerId}/pins/${pinId}/photo`, data)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  deletePhoto(pinId, layerId) {
    return apiFileClient
      .delete(`/drawings/${layerId}/pins/${pinId}/photo`)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  editPin(pinId, layerId, data) {
    return apiV2Client
      .put(`/drawings/${layerId}/pins/${pinId}`, data)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  deletePin(pinId, layerId) {
    return apiV2Client
      .delete(`/drawings/${layerId}/pins/${pinId}/delete`)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  updatePinStatus(pinId, layerId, status) {
    return apiV2Client
      .put(`/drawings/${layerId}/pins/${pinId}/change-status/${status}`)
      .then((response) => {
        return response;
      })
      .catch(handleError());
  },
  voteForPin(pinId, layerId) {
    return apiV2Client
      .post(`/drawings/${layerId}/pins/${pinId}/vote`)
      .then((response) => {
        return response;
      })
      .catch(handleError({ 403: 'Pro tento pin jste už hlasovali.' }));
  }
};
